/*
此資料 base on API-8 的回傳，再加上 API-2 的補充內容
 */
import _ from 'lodash';
import cookie from 'vue-cookies';

/**
 * 試算資料
 */
const state = () => ({
    uid: null, // 個人識別代碼(FPC) 
    EstimateId: null,
    FK: null,
    CompelDatePeriod: null,
    CompelDateBegin: null,
    CompelDateEnd: null,
    ChoiceDatePeriod: null,
    ChoiceDateBegin: null,
    ChoiceDateEnd: null,
    AssuredId: null,
    AssuredName: null,
    AssuredType: null,
    AssuredBirthDay: null,
    AssuredSex: null,
    AssuredMarriage: null,
    AssuredAddress: null,
    AssuredZip: null,
    AssuredTel: null,
    AssuredMobilPhone: null,
    AssuredEmail: null,
    AssuredDeputy: null,
    AssuredAssets: null,
    AssuredCntryRiskLevel: null,
    Assured_cntry: null,
    AssuredRiskLevelOccup: null,
    AssuredOccup: null,
    UserNames: null,
    ARCIssueDate: null,
    ARCDeadline: null,
    ARCNo: null,
    PeriodOfStay: null,
    PurposeOfCome: null,
    PurposeOfInsurance: null,
    ApplicantID: null,
    ApplicantName: null,
    ApplicantType: null,
    ApplicantBirthDay: null,
    ApplicantSex: null,
    ApplicantAddress: null,
    ApplicantZip: null,
    ApplicantMobilPhone: null,
    ApplicantTelDay: null,
    ApplicantEmail: null,
    ApplicantDeputy: null,
    ApplicantAssets: null,
    ApplicantRelation: null,
    ApplicantCntryRiskLevel: null,
    Applicant_cntry: null,
    ApplicantRiskLevelOccup: null,
    ApplicantOccup: null,
    ApplicantPremSource: null,
    ApplicantARCIssueDate: null,
    ApplicantARCDeadline: null,
    ApplicantARCNo: null,
    ApplicantPeriodOfStay: null,
    ApplicantPurposeOfCome: null,
    ApplicantPurposeOfInsurance: null,
    TagId: null,
    BrandId: null,
    BrandName: null,
    BrandGroupId: null,
    BrandGroupName: null,
    CarStyle: null,
    CarStyleName: null,
    IssueDate: null,
    ProductYear: null,
    ProductMonth: null,
    CarType: null,
    CarTypeName: null,
    Cylinder: null,
    EngineId: null,
    BodyId: null,
    CarPrice: null,
    TransportAmount: null,
    TransportUnitType: null,
    VehicleModelName: null,
    PowerType: null,
    CarSeries: null,
    Status: null,
    ExamineDate: null,
    EntryDate: null,
    CompelFactor: null,
    TradevanLastCompelPolicyDateEnd: null, // 關貿查詢前期強制保單終止日期
    DrunkDrivingTime: null, // 酒後駕車次數
    CarDamageAccidentFactor: null, // 車體賠款係數
    LiaFactor: null,
    LiaAccidentTimesInThreeYears: null,
    PremiumChoice: null,
    PremiumCompel: null,
    PolicyType: null,
    LastEstimateId: null,
    SentMailReceiver: null,
    SentMailReceiverName: null,
    SentMailReceiverPhone: null,
    Corp: null,
    InsCategory: null,
    ActivityCode: null,
    CustomerNote: null,
    PersonalNoteDate: null,
    InsuranceNoteDate: null,
    ServiceNoteDate: null,
    PolicyEntry: null,
    Depreciate: 'P',
    KYCDate: null,
    Ownership: null,
    OwnershipAddress: null,
    UpdateBirthday: false,
    ClarityId: null,
    IsOwner: null,
    MidStatus: null,
    InsuranceMessage: [],
    TelemarketingId: null
});

const actions = {};

const getters = {
    /**
     * 讀取資料
     * @param {*} state
     * @returns {Object}
     */
    getData: (state) => {
        if (state.AssuredMarriage) state.AssuredMarriage = parseInt(state.AssuredMarriage);
        return state;
    },
    /**
     * 是否已填寫要保人身分證字號/居留證/統一編號
     * @param {*} state
     * @returns {Boolean}
     */
    isApplicantDataFilledOut: (state) => {
        return !!state.ApplicantID;
    },
    getAssuredARC: (state) => {
        return {
            ARCIssueDate: state.ARCIssueDate,
            ARCDeadline: state.ARCDeadline,
            ARCNo: state.ARCNo,
            PeriodOfStay: state.PeriodOfStay,
            PurposeOfCome: state.PurposeOfCome,
            PurposeOfInsurance: state.PurposeOfInsurance
        };
    },
    getApplicantARC: (state) => {
        return {
            ARCIssueDate: state.ApplicantARCIssueDate,
            ARCDeadline: state.ApplicantARCDeadline,
            ARCNo: state.ApplicantARCNo,
            PeriodOfStay: state.ApplicantPeriodOfStay,
            PurposeOfCome: state.ApplicantPurposeOfCome,
            PurposeOfInsurance: state.ApplicantPurposeOfInsurance
        };
    }
};

const mutations = {
    /**
     * 清除資料
     * @param {*} state
     */
    clear(state) {
        _.forEach(state, (value, key) => {
            state[key] = null;
            if (key === 'Depreciate') state[key] = 'P'; // 折舊率預設值
            if (key === 'uid') { // 個人識別代碼(FPC) 
                if (window.localStorage.fpc) {
                    state[key] = window.localStorage.fpc;
                }
            };
            if(key === 'ClarityId'){ //Clarity使用者識別碼
                if(cookie.get('_clck')?.split('|')[0]){
                    state[key] = cookie.get('_clck').split('|')[0];
                }
            }
        });
    },
    /**
     * API-8 的回傳資料
     * @param {*} state
     * @param {*} payload
     * @returns {Object}
     */
    setData(state, payload) {
        if (!payload) return;

        _.forEach(state, (value, key) => {
            if (typeof payload[key] !== 'undefined') {
                state[key] = payload[key];
            }
            if (key === 'uid') { // 個人識別代碼(FPC) 
                if (window.localStorage.fpc) {
                    state[key] = window.localStorage.fpc;
                }
            };
             if(key === 'ClarityId'){ //Clarity使用者識別碼
                if(cookie.get('_clck')?.split('|')[0]){
                    state[key] = cookie.get('_clck').split('|')[0];
                }
             }
        });
    },
    /**
     * 折舊率
     * @param {*} state
     * @param {*} payload
     */
    setDepreciate(state, payload) {
        state.Depreciate = payload;
    },
    /**
     * 依帶入的 key 值設定單一 state 的 value，因為不知道 estimate 有可能有哪些欄位，所以用這個方法直接把 API 回傳的資料帶入
     * @param {*} state
     * @param {*} payload
     */
    setValue(state, payload) {
        state[payload.key] = payload.value;
    },
    setAssuredARC(state, payload){
        if(!!payload.arcObj){
            state.ARCIssueDate = payload.arcObj.ARCIssueDate;
            state.ARCDeadline = payload.arcObj.ARCDeadline;
            state.ARCNo = payload.arcObj.ARCNo;
            state.PeriodOfStay = payload.arcObj.PeriodOfStay;
            state.PurposeOfCome = payload.arcObj.PurposeOfCome;
            state.PurposeOfInsurance = payload.arcObj.PurposeOfInsurance;
        }
    },
    setApplicantARC(state, payload){
        if(!!payload.arcObj){
            state.ApplicantARCIssueDate = payload.arcObj.ARCIssueDate;
            state.ApplicantARCDeadline = payload.arcObj.ARCDeadline;
            state.ApplicantARCNo = payload.arcObj.ARCNo;
            state.ApplicantPeriodOfStay = payload.arcObj.PeriodOfStay;
            state.ApplicantPurposeOfCome = payload.arcObj.PurposeOfCome;
            state.ApplicantPurposeOfInsurance = payload.arcObj.PurposeOfInsurance;
        }
    },
    setSentMailReceiver(state, payload){
        if(!!payload){
            state.SentMailReceiver = payload.email;
            state.SentMailReceiverName = payload.name;
            state.SentMailReceiverPhone = payload.mobile;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
